import { createRouter, createWebHistory } from "vue-router";
import AuthCallbackView from "@/views/AuthCallbackView.vue";
import KycDocumentUploadView from "@/views/KycDocumentUploadView.vue";
import KycStatusView from "@/views/KycStatusView.vue";
import LoginView from "@/views/LoginView.vue";
import OnboardingView from "@/views/OnboardingView.vue";
import ExternalIdNotFoundView from "@/views/ExternalIdNotFoundView.vue";
import PaymentCheckoutView from "@/views/PaymentCheckoutView.vue";
import PaymentReturnView from "@/views/PaymentReturnView.vue";
import TokenPurchaseView from "@/views/TokenPurchaseView.vue";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      redirect: { name: "onboarding" },
    },
    {
      path: "/onboarding",
      name: "onboarding",
      component: OnboardingView,
      meta: { requiresAuth: true },
    },
    {
      path: "/external-id-not-found",
      name: "external-id-not-found",
      component: ExternalIdNotFoundView,
      meta: { requiresAuth: true },
    },
    {
      path: "/kyc-status",
      name: "kyc-status",
      component: KycStatusView,
      meta: { requiresAuth: true },
    },
    {
      path: "/kyc-document-upload",
      name: "kyc-document-upload",
      component: KycDocumentUploadView,
      meta: { requiresAuth: true },
    },
    {
      path: "/token-kauf",
      name: "token-purchase",
      component: TokenPurchaseView,
      meta: { requiresAuth: true },
    },
    {
      path: "/payment/checkout",
      name: "payment-checkout",
      component: PaymentCheckoutView,
      meta: { requiresAuth: true },
    },
    {
      path: "/payment/return",
      name: "payment-return",
      component: PaymentReturnView,
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: LoginView,
      meta: { guestOnly: true },
    },
    {
      path: "/callback",
      name: "auth-callback-compat",
      redirect: (to) => ({
        path: "/auth/callback",
        query: to.query,
        hash: to.hash,
      }),
    },
    {
      path: "/auth/callback",
      name: "auth-callback",
      component: AuthCallbackView,
      meta: { authCallback: true },
    },
  ],
});
